if (!customElements.get('kaffinity-navigation')) {
  customElements.define('kaffinity-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.buttons = [...this.querySelectorAll('.kn-toggle')];
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const opening = button.getAttribute('aria-expanded') !== 'true';
        this.close();
        if (opening) {
          button.setAttribute('aria-expanded', 'true');
          document.getElementById(button.getAttribute('aria-controls')).hidden = false;
        }
      }, options));
      this.addEventListener('keydown', event => {
        const button = event.target.closest('.kn-item')?.querySelector('.kn-toggle');
        if (event.key === 'Escape' && this.buttons.some(b => b.getAttribute('aria-expanded') === 'true')) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          button?.focus();
        } else if (event.key === 'ArrowDown' && event.target.matches('.kn-toggle')) {
          event.preventDefault();
          if (button.getAttribute('aria-expanded') !== 'true') button.click();
          document.getElementById(button.getAttribute('aria-controls')).querySelector('a').focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        // A blur occurs before a pointer click finishes. Never hide its target
        // based on the transient document.activeElement (or a null target).
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); }, options);
      window.addEventListener('resize', () => this.close(), options);
    }
    close() {
      this.buttons.forEach(button => {
        button.setAttribute('aria-expanded', 'false');
        document.getElementById(button.getAttribute('aria-controls')).hidden = true;
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
